export enum LoanTransactionTypeId {
	DISBURSEMENT = 0,
	PAYMENT = 1,
	TAKE_BACK = 2,
	REFUND = 3,
	INTEREST_CORRECTION = 4,
	CHARGE_OFF = 5,
	INSURANCE_PREMIUM = 6,
	SCRA_INTEREST_REFUND = 7,
	CPI_PREMIUM = 8,
	CPI_PREMIUM_REFUND = 9,
	PRINCIPAL_INCREASE = 10,
	PRINCIPAL_DECREASE = 11,
	RECOVERY = 12,
	PAYMENT_REFUND = 13,
}
